import { commitMutation,
  graphql } from 'react-relay';
import environment from '../../.';
import { basicMutationOnCompleted, onErrorMutation } from '../common/common';

export const mutation = graphql`
mutation InviteMemberMutation($email: String!, $roles: [NewUserRoleInput!]!) {
  inviteMember(email: $email, roles: $roles) {
    ok
    error
  }
}
`;

export default ({ email, roles }, done) => {
  const variables = {
    email,
    roles
  };

  commitMutation(
    environment(),
    {
      mutation,
      variables,
      onCompleted: ({ inviteMember }) => basicMutationOnCompleted(inviteMember, done),
      onError: error => onErrorMutation(error, done)
    }
  );
};
